import { connect } from 'react-redux'

import { createLoadingSelector } from '../../redux/loading/loading.selectors'

import WithSpinner from '../with-spinner/with-spinner.component'
import EsignContent from './esign-content.component'
import CloudCertModal from '../cloud-cert-modal/cloud-cert-modal.component'

const loadingSelector = createLoadingSelector(['FETCH_TRANSACTION', 'FETCH_USER', 'FETCH_USER_INFO','FETCH_TSP','SEND_TO_ESIGNER', 'SEND_TO_EMBEDDING_API'])

const mapSteteToProps = (state) => ({
  isLoading: loadingSelector(state),
  data: state.transaction.data,
  signedData: state.transaction.signedData,
  user: state.currentUser.user,
  cloudUser: state.currentUser.cloudUser,
  cloudCertModal: state.cloudCertModal,
  tsp: state.tsp
})

const EsignContentContainer = connect(mapSteteToProps)(WithSpinner(CloudCertModal(EsignContent)))

export default EsignContentContainer